import { BaseModel } from "../Generics/BaseModel"

export class AddressEntity extends BaseModel {
  id: number

  label: string

  street: string

  number: string

  city: string

  state: string

  zipCode: string

  neighborhood: string

  complement: string

  country: string

  latitude?: number

  longitude?: number

  constructor(data: Partial<AddressEntity> = {}) {
    super()

    this.id = data.id ?? 0

    this.street = data.street ?? ""

    this.number = data.number ?? ""

    this.city = data.city ?? ""

    this.state = data.state ?? ""

    this.zipCode = data.zipCode ?? ""

    this.label = data.label ?? ""

    this.neighborhood = data.neighborhood ?? ""

    this.complement = data.complement ?? ""

    this.country = data.country ?? ""

    this.latitude = data.latitude

    this.longitude = data.longitude
  }
}
